import { Controller } from "@hotwired/stimulus";
import { PreviewPopupHelper } from "./preview-popup-helper.js";

export class PopupController extends Controller {
  static targets = ["checkbox"]
  static values = { 
    id: String
  }

  connect() {
    // プレビュー機能での表示制御をチェック
    const previewHelper = new PreviewPopupHelper(this);
    if (!previewHelper.shouldShowPopup()) {
      return;
    }
    
    // 1秒後に表示
    setTimeout(() => {
      this.showPopup()
    }, 1000)
  }

  showPopup() {
    const overlay = this.element.querySelector('.popup__overlay')
    this.element.style.display = 'block'
    
    // フェードイン
    setTimeout(() => {
      overlay.classList.add('popup__overlay--show')
    }, 10)
  }

  hidePopup() {
    const overlay = this.element.querySelector('.popup__overlay')
    overlay.classList.remove('popup__overlay--show')
    
    // フェードアウト後に非表示
    setTimeout(() => {
      this.element.style.display = 'none'
    }, 300)
  }

  close() {
    const isNeverShow = this.hasCheckboxTarget && this.checkboxTarget.checked
    const dismissType = isNeverShow ? 'permanent' : 'temporary'
    
    this.dismissPopup(dismissType)
    this.hidePopup()
  }

  clickLink() {
    // リンククリック時は一時的にポップアップを非表示
    this.dismissPopup('temporary')
    this.hidePopup()
    // aタグによる遷移は自動処理
  }

  overlayClick(event) {
    // オーバーレイ部分をクリックした場合のみ閉じる
    if (event.target === event.currentTarget) {
      this.hidePopup()
    }
  }

  dismissPopup(dismissType) {
    if (!this.idValue) return
    
    // プレビューモードでのサーバーリクエストスキップ判定
    const previewHelper = new PreviewPopupHelper(this);
    if (previewHelper.shouldSkipServerRequest()) {
      return;
    }
    
    // サーバーにクッキー設定リクエストを送信
    fetch('/api/v1/customer/popups/dismiss', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        popup_id: this.idValue,
        dismiss_type: dismissType
      })
    }).catch(error => {
      console.error('Failed to dismiss popup:', error)
    })
  }
}

// Registered in customer.js